import { useFlowaesStore } from '../store/useFlowaesStore';
import { useRef, useMemo } from 'react';

export function useTerminalSettings() {
  const store = useFlowaesStore();
  const idleTimerRef = useRef<any>(null);

  const proxiedStore = useMemo(() => {
    const proxy: any = { ...store, idleTimerRef };
    for (const key of Object.keys(store)) {
      if (key.startsWith('set')) {
        const originalSetter = (store as any)[key];
        proxy[key] = (val: any) => {
          if (typeof val === 'function') {
            const stateKey = key.charAt(3).toLowerCase() + key.slice(4);
            const currentState = (useFlowaesStore.getState() as any)[stateKey];
            originalSetter(val(currentState));
          } else {
            originalSetter(val);
          }
        };
      }
    }
    return proxy;
  }, [store]);

  return proxiedStore;
}
